import { render, staticRenderFns } from "./workerInfo.vue?vue&type=template&id=27472f1a&"
import script from "./workerInfo.vue?vue&type=script&lang=js&"
export * from "./workerInfo.vue?vue&type=script&lang=js&"
import style0 from "./workerInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports